<div class="smash-input-tag-container" [ngClass]="{'disabled': disabled, 'focused': focused, 'error': !!error}">
    <div class="smash-tag-container">
        <!-- tag list -->
        <ul class="smash-tag-list-container">
            <li *ngFor="let tag of tagList" class="smash-tag">
                <div class="tag">{{tag}}</div>
                <div class="delete-icon" (click)="deleteItem(tag)">&times;</div>
            </li>
        </ul>
        <div class="smash-input-suggest-container">
            <input #searchElement type="text" [attr.invalid]="error ? '' : null" autocomplete="nope" [autocapitalize]="autocapitalize" (keyup)='autoSuggest($event)'
                (keydown.space)='processInput($event)' (blur)='processInput($event)' (keydown.enter)='processInput($event)' [value]="value"
                [(ngModel)]="value" placeholder="{{ 'UPLOADER_EMAIL_FORM_PLACEHOLDER_RECIPIENTS_EMAILS' | translate }}"
                [attr.disabled]="disabled ? '' : null" (focus)="onFocus()" (focusout)="onFocusOut()" />
            <!-- suggest list -->
            <ul class="smash-suggest-list-container" *ngIf="showSuggest">
                <li *ngFor="let suggest of suggestListBuffer" class="smash-suggest" (click)="addTag($event, suggest)">
                    <div class="suggest">{{suggest}}</div>
                    <div class="suggest delete-icon " (click)="deleteSuggestion($event, suggest)">&times;</div>
                </li>
            </ul>
        </div>

    </div>

    <div class="smash-counter-container">
        <!-- tag count -->
        <div class="tag-counter" *ngIf="!contactsExpanded && contactCount > 1">
            + {{ contactCount }}
        </div>
    </div>
</div>